import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  AccountIconType,
  getIllustrationKey,
} from 'shared/components/vxl/AccountIcon/AccountIcon.helpers';
import Illustration from 'shared/components/vxl/Illustration/Illustration';

export interface AccountIconProps {
  /** Image based on AccountIconType */
  product: AccountIconType;
}

export const AccountIcon = ({ product }: AccountIconProps) => {
  return (
    <View style={baseStyles.container} role="img" accessible>
      <Illustration illustration={getIllustrationKey(product)} />
    </View>
  );
};

const baseStyles = StyleSheet.create({
  container: {
    alignItems: 'center',
    borderRadius: 20,
    height: 40,
    justifyContent: 'center',
    width: 40,
  },
});

export default AccountIcon;
